import { render, staticRenderFns } from "./AddressSearchModal.vue?vue&type=template&id=07d45bd3&scoped=true"
import script from "./AddressSearchModal.vue?vue&type=script&lang=js"
export * from "./AddressSearchModal.vue?vue&type=script&lang=js"
import style0 from "./AddressSearchModal.vue?vue&type=style&index=0&id=07d45bd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d45bd3",
  null
  
)

export default component.exports